var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticParseInt.js
// module id = 165
// module chunks = 75